/**
 * 全屏页面切换状态维护
 * 移动端去除底部百宝箱逻辑，无需根据 UIState 变化控制显隐
 * 依然保留 UIState 逻辑，留备其他功能使用
 */
import { observable } from 'mobx';

export class MobileUIState {
    @observable public static isPlaying = false;
    @observable public static isEditing = false;
    @observable public static isMenuShow = false;
    @observable public static isPasswordModalShow = false;
}
